interface SkeletonProps {
  /** lines: text rows · table: header + rows · chart: one block · tiles: a row of stat boxes */
  kind?: "lines" | "table" | "chart" | "tiles";
  rows?: number;
  className?: string;
}

const WIDTHS = ["w-5/6", "w-2/3", "w-3/4", "w-1/2", "w-4/5", "w-3/5"];

/**
 * Placeholder that holds the space of the content it stands in for, so the
 * page doesn't jump when data arrives.
 */
export function Skeleton({ kind = "lines", rows = 3, className = "" }: SkeletonProps) {
  const body =
    kind === "chart" ? (
      <div className={`skeleton rounded-lg ${className || "h-64"}`} />
    ) : kind === "tiles" ? (
      <div className={`grid grid-cols-2 md:grid-cols-4 gap-3 ${className}`}>
        {Array.from({ length: rows || 4 }, (_, i) => (
          <div key={i} className="skeleton h-16 rounded-xl" />
        ))}
      </div>
    ) : kind === "table" ? (
      <div className={`space-y-2 ${className}`}>
        <div className="skeleton h-3 w-full rounded opacity-60" />
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className="skeleton h-8 w-full rounded" />
        ))}
      </div>
    ) : (
      <div className={`space-y-2 ${className}`}>
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className={`skeleton h-4 rounded ${WIDTHS[i % WIDTHS.length]}`} />
        ))}
      </div>
    );

  return (
    <div role="status" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading</span>
      {body}
    </div>
  );
}
